<template>
  <div
    class="relative inline-flex items-center justify-center w-7 h-7 overflow-hidden bg-red-300 rounded-full cursor-pointer">
    <span class="font-semibold text-red-600 dark:text-red-300">
      {{ userName.slice(0, 1) }}
    </span>
  </div>
</template>
<script lang="ts" setup>
defineProps({
  userName: {
    type: String,
    required: true,
  },
});
</script>
